module.exports = __webpack_public_path__ + "static/media/planta.786f8fd4.svg";